import { Col, Row, Switch } from "antd";
import { get, isEmpty, set } from "lodash";
import { useTranslation } from "react-i18next";
import { MdNumbers, MdOutlineFreeCancellation } from "react-icons/md";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const SponsorshipMembership = ({
  formProps,
  values,
  setPercent,
  isFieldRequired,
  initialValues,
  errors,
  setDisabled,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.ADVANTAGES}-section`}
    >
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.ADVANTAGES.TITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <Form
              type="highlight"
              title={
                SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP
                  .TITLE
              }
            >
              <Row gutter={[16, 16]}>
                <Col lg={24} xs={24}>
                  <Input
                    optional
                    placeholder={
                      SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                        .SPONSORSHIP_MEMBERSHIP.FULLNAME
                    }
                    label={
                      SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                        .SPONSORSHIP_MEMBERSHIP.FULLNAME
                    }
                    icon={<MdOutlineFreeCancellation size={16} />}
                    defaultValue={get(
                      initialValues,
                      "additionalInfo.sponsor.fullName",
                    )}
                    errors={errors["additionalInfo.sponsor.fullName"]}
                    touched={
                      !isEmpty(errors["additionalInfo.sponsor.fullName"])
                    }
                    onChange={({ target: { value } }) => {
                      set(
                        initialValues,
                        "additionalInfo.sponsor.fullName",
                        value,
                      );
                    }}
                    onBlur={() => setPercent(initialValues)}
                    required={isFieldRequired(
                      "additionalInfo.sponsor.fullName",
                    )}
                  />
                </Col>
                <Col lg={24} xs={24}>
                  <Input
                    optional
                    placeholder={
                      SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                        .SPONSORSHIP_MEMBERSHIP.SLM_ID
                    }
                    label={
                      SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                        .SPONSORSHIP_MEMBERSHIP.SLM_ID
                    }
                    icon={<MdOutlineFreeCancellation size={16} />}
                    defaultValue={get(
                      initialValues,
                      "additionalInfo.sponsor.slmId",
                    )}
                    errors={errors["additionalInfo.sponsor.slmId"]}
                    touched={!isEmpty(errors["additionalInfo.sponsor.slmId"])}
                    onBlur={() => setPercent(initialValues)}
                    onChange={({ target: { value } }) => {
                      set(initialValues, "additionalInfo.sponsor.slmId", value);
                    }}
                    required={isFieldRequired("additionalInfo.sponsor.slmId")}
                  />
                </Col>
                <Col lg={24} xs={24}>
                  <Select
                    theme="light"
                    optional
                    options={[1, 2, 3, 4, 5, 6, 7, 8].map((value) => ({
                      value,
                      label: value,
                    }))}
                    placeholder={
                      SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                        .SPONSORSHIP_MEMBERSHIP.MONTHS_OFFERED.PLACEHOLDER
                    }
                    label={
                      SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                        .SPONSORSHIP_MEMBERSHIP.MONTHS_OFFERED.LABEL
                    }
                    icon={<MdNumbers size={16} />}
                    defaultValue={get(
                      initialValues,
                      "additionalInfo.sponsor.monthsOffered",
                    )}
                    errors={errors["additionalInfo.sponsor.monthsOffered"]}
                    touched={
                      !isEmpty(errors["additionalInfo.sponsor.monthsOffered"])
                    }
                    onChange={(value) => {
                      set(
                        initialValues,
                        "additionalInfo.sponsor.monthsOffered",
                        value,
                      );
                    }}
                    onBlur={() => setPercent(initialValues)}
                    required={isFieldRequired(
                      "additionalInfo.sponsor.monthsOffered",
                    )}
                  />
                </Col>
              </Row>
            </Form>
          </Col>
          <Col lg={24} xs={24}>
            <Form
              type="highlight"
              title={
                SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.SPONSORSHIP_MEMBERSHIP
                  .COUPLE_OFFER.TITLE
              }
            >
              <Row gutter={[16, 16]}>
                <Col lg={24} xs={24}>
                  <div className="d-flex justify--between">
                    <span className="contact-stepper__content--radio--title">
                      {
                        SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                          .SPONSORSHIP_MEMBERSHIP.COUPLE_OFFER
                          .IS_SPOUSE_A_MEMBER.LABEL
                      }
                    </span>
                    <Switch
                      className="contact-stepper__content--radio--switch button__switch"
                      checkedChildren={
                        SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                          .SPONSORSHIP_MEMBERSHIP.COUPLE_OFFER
                          .IS_SPOUSE_A_MEMBER.OPTIONS.YES
                      }
                      unCheckedChildren={
                        SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                          .SPONSORSHIP_MEMBERSHIP.COUPLE_OFFER
                          .IS_SPOUSE_A_MEMBER.OPTIONS.NO
                      }
                      defaultChecked={get(
                        initialValues,
                        "additionalInfo.sponsor.isSpouseAMember",
                      )}
                      onChange={(e) => {
                        set(
                          initialValues,
                          "additionalInfo.sponsor.isSpouseAMember",
                          e,
                        );
                        if (e === false)
                          set(
                            initialValues,
                            "additionalInfo.sponsor.spouseIdentifier",
                            undefined,
                          );

                        setDisabled((prev) => ({
                          ...prev,
                          additionalInfo: {
                            ...prev.additionalInfo,
                            sponsor: {
                              ...prev.additionalInfo.sponsor,
                              spouseIdentifier: !e,
                            },
                          },
                        }));
                        setPercent(initialValues);
                      }}
                      onBlur={() => setPercent(initialValues)}
                    />
                  </div>
                </Col>
                {get(
                  initialValues,
                  "additionalInfo.sponsor.isSpouseAMember",
                ) && (
                  <Col lg={24} xs={24}>
                    <Input
                      placeholder={
                        SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                          .SPONSORSHIP_MEMBERSHIP.COUPLE_OFFER.ADHERENT_NUMBER
                          .PLACEHOLDER
                      }
                      label={
                        SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION
                          .SPONSORSHIP_MEMBERSHIP.COUPLE_OFFER.ADHERENT_NUMBER
                          .LABEL
                      }
                      icon={<MdOutlineFreeCancellation size={16} />}
                      defaultValue={get(
                        initialValues,
                        "additionalInfo.sponsor.spouseIdentifier",
                      )}
                      errors={errors["additionalInfo.sponsor.spouseIdentifier"]}
                      touched={
                        !isEmpty(
                          errors["additionalInfo.sponsor.spouseIdentifier"],
                        )
                      }
                      onBlur={() => setPercent(initialValues)}
                      onChange={({ target: { value } }) => {
                        set(
                          initialValues,
                          "additionalInfo.sponsor.spouseIdentifier",
                          value,
                        );
                      }}
                      required
                    />
                  </Col>
                )}
              </Row>
            </Form>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SponsorshipMembership;
